<template>
  <div>
<!--    <div class="d-flex">-->
<!--      <el-tooltip content="如何使用标签" placement="bottom">-->
<!--        <el-button round>-->
<!--          <el-popover-->
<!--              placement="right"-->
<!--              trigger="click"-->
<!--              effect="light">-->
<!--            <div class="recommend">-->
<!--              <div class="mt-2"><h3 class="font-weight-bold border-bottom pb-2">如何使用标签</h3></div>-->
<!--              <div><i class="el-icon-user"></i><span>群主/群员都可以给自己的帖子添加标签。</span></div>-->
<!--              <div><i class="el-icon-view"></i><span>添加合适的标签，能方便分类检索，帖子也更容易被读者发现</span></div>-->
<!--              <div><i class="el-icon-more"></i><span>点击帖子底部即可添加标签</span></div>-->
<!--              <div class="col-12 pt-4 col-md-12 mx-0 mt-0"><img style="width:500px" src="/img/recommend.webp"-->
<!--                                                                class="logo"></div>-->
<!--            </div>-->
<!--            <i size="medium" style="font-size: 24px" class="el-icon-warning-outline text-secondary"-->
<!--               slot="reference"></i>-->
<!--          </el-popover>-->
<!--        </el-button>-->
<!--      </el-tooltip>-->
<!--    </div>-->
    <el-tag class="mr-2" v-for="item in tags" :key="item.id">
       <i size="mini" class="el-icon-price-tag trans"></i>
      {{item.name}}</el-tag>
  </div>
</template>

<script>
import {Tag} from 'element-ui';
export default {
  name: "TagBar",
  props:{
    tags:Array
  },
  components: {
    [Tag.name]: Tag,
  },
  created() {
  },
}
</script>

<style scoped>
.el-tag{
  color: #2196f3;
  font-size: 16px;
  border-radius: 120px;
  padding: 0 14px;
  background: rgba(0,102,255,.1);
}
i.el-icon-price-tag.trans{
  transform: rotate(52deg);
}
</style>